const customsprocedure = {
    getlist: 'customsprocedure/getlist',
    add: 'customsprocedure/add',
    update: 'customsprocedure/update',
    remove: 'customsprocedure/remove',
    get: 'customsprocedure/get',
    getall: 'customsprocedure/getall-by-admin',
    clearcache: 'customsprocedure/clear-cache',
}
export default customsprocedure
